import { AuthRoutes } from 'routes';

export const COMPANY_DOCS_SLACK_PATH = '/company-docs-slack';

// Session replay records request URLs and response bodies, so pages that fetch a secret or a bulk
// list of customer documents never record.
const NO_REPLAY_PATHS: string[] = [AuthRoutes.SecureUploadRequest, COMPANY_DOCS_SLACK_PATH];

export const isNoReplayPath = (pathname: string): boolean => NO_REPLAY_PATHS.includes(pathname.replace(/\/+$/, ''));

/** True for a full or relative URL whose path is a no-replay page, whatever query or fragment follows. */
export const isNoReplayUrl = (url: string): boolean => {
  try {
    return isNoReplayPath(new URL(url, window.location.origin).pathname);
  } catch {
    return false;
  }
};

export const isOnNoReplayPage = (): boolean =>
  typeof window !== 'undefined' && isNoReplayPath(window.location.pathname);
